import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { translate } from "../../../i18n";
import { GET_TIME_WINDOW_GROUPS_QUERY_KEY } from "./useGetTimeWindowGroups";

export const useDeleteTimeWindowGroup = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const toast = useToast();
    return useMutation({
        mutationKey: ['deleteTimeWindowGroup'],
        mutationFn: (id: string) =>
            client.fetchApi({
                endpoint: `time-windows/groups/${id}`,
                method: 'DELETE'
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_TIME_WINDOW_GROUPS_QUERY_KEY() });
            toast({ title: translate('time_windows.group_deleted'), status: 'success', duration: 2000 });
        },
        onError: () => {
            toast({ title: translate('time_windows.delete_group_error'), status: 'error' });
        }
    });
};